import { Component, OnInit, Input, ElementRef, HostListener, Output, EventEmitter, AfterViewInit } from '@angular/core';

export interface MultiSelectItem {
  data: Object;
  selected: boolean;
}

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss']
})
export class MultiSelectComponent implements OnInit, AfterViewInit {

  private inputMap: Map<string, MultiSelectItem>;
  private outputMap: Map<string, MultiSelectItem>;
  private onTouchedCallback: () => void;
  o: boolean;
  @Input() title;
  @Input() placeholder;
  @Input() rightItem;
  @Input() wrap: boolean;
  @Input() misfit: boolean;
  @Input() preicon: boolean;
  @Input() lowercase: boolean;
  @Input() mini: boolean;
  @Input() disabled: boolean;
  @Input() itemId: string;
  @Input() itemCode: string;
  @Input() limit: number;
  @Output() outputEvent = new EventEmitter<any>();
  @Input() public set input(data) {
    if (data) {
      let id = 'id';
      if (this.itemId) {
        id = this.itemId;
      }
      this.inputMap.clear();
      for (const i of data) {
        this.inputMap.set(i[id], { data: i, selected: false });
      }
      if (data.length === 0) {
        this.inputMap.clear();
      }
    }
  }
  @Input() public set output(data) {
    if (data) {
      let id = 'id';
      if (this.itemId) {
        id = this.itemId;
      }
      this.outputMap.clear();
      for (const i of data) {
        this.outputMap.set(i[id], {data: i, selected: true});
      }
      if (data.length === 0) {
        this.outputMap.clear();
      }
    }
  }


  constructor(private eRef: ElementRef) {
            this.inputMap = new Map<string, MultiSelectItem>();
            this.outputMap = new Map<string, MultiSelectItem>();
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this.outputMap.forEach((v, k) => {
      if (this.inputMap.get(k)) {
        this.inputMap.set(k, { data: v.data, selected: true });
      }
    });
  }

  @HostListener('document:click', ['$event.target'])
  public outsideClick(e) {
    if (!this.eRef.nativeElement.contains(e) && (this.o)) {
      this.o = !this.o;
    }
  }

  public toggle() {
    if (!this.disabled) {
      this.o = !this.o;
    }
  }

  public getValues() {
    if (this.outputMap && this.outputMap.size > 0) {
      return Array.from(this.outputMap.values()).map(v => v.data[this.itemCode]).join(', ');
    }
    return null;
  }

  public clickItem(selected) {
    if (this.outputMap.has(selected.key)) {
      this.outputMap.delete(selected.key);
      this.updateInputMap();
      this.outputEvent.emit(this.outputMap);
    } else {
      if (this.outputMap.size < this.limit) {
        selected.value.selected = true;
        this.outputMap.set(selected.key, selected.value);
        this.updateInputMap();
        this.outputEvent.emit(this.outputMap);
      }
    }
  }

  public updateInputMap() {
    this.inputMap.forEach(i => {
      if (this.outputMap.has(i.data[this.itemId])) {
        i.selected = true;
      } else {
        i.selected = false;
      }
    });
  }

  onBlur() {
    try {
      if (typeof this.onTouchedCallback() !== 'undefined') {
        this.onTouchedCallback();
      }
    } catch (e) { }
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}
